import styled from 'styled-components';

import { colors } from '@crehana/ui';

const { primaryMain, blueDark } = colors;

export const ImageWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 466px;
  }
`;

export const Article = styled.article`
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 368px;
  }
`;

export const ContentWrapper = styled.div`
  * {
    font-family: Poppins, SF Pro Display, -apple-system, BlinkMacSystemFont,
      Roboto, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji;
  }
  p,
  a {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 24px;
  }

  h2,
  h2 > a {
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 24px;
    color: ${blueDark};
  }

  h3,
  h3 > a {
    font-weight: 700;
    font-size: 20px;
    text-align: left !important;
    margin-bottom: 24px;
    color: ${blueDark};
  }

  h4,
  h3 > a {
    font-weight: 700;
    font-size: 18px;
    text-align: left !important;
    margin-bottom: 24px;
    color: ${blueDark};
  }

  h4 {
    font-weight: 700;
    font-size: 18px;
    text-align: left !important;
    margin-bottom: 24px;
    color: #070e27;
  }

  img {
    max-width: 100%;
    height: auto !important;
  }

  a {
    font-weight: bold;
    color: ${primaryMain};
  }

  p {
    iframe {
      width: 100%;
      height: 30vh;

      ${props => props.theme.breakpoints.up('md')} {
        height: 50vh;
      }
    }
  }

  em {
    font-size: 18px;
    font-style: normal;
    font-style: italic;
  }

  /* ul {
    margin-left: 20px;

    li,
    li > a {
      list-style-type: disc !important;
      font-weight: 400;
      font-size: 18px;
      margin-bottom: 24px;
    }
  }
  ol {
    margin-left: 20px;

    li,
    li > a,
    p,
    span {
      list-style-type: decimal !important;
      font-weight: 400;
      font-size: 18px;
      margin-bottom: 24px;
    }
  } */

  a:hover {
    cursor: pointer;
  }
`;
